import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import axiosClient from '../../../../config/axios.js';

function EditTypeService() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { Formik } = formik;

    const [initialValues, setInitialValues] = useState({
        type_service_name: ''
    });

    useEffect(() => {
        axiosClient.get(`/typeServices/${id}`).then(response => {
            const { type_service_name } = response.data;
            setInitialValues({ type_service_name });
        }).catch(error => {
            console.error('Error fetching typeService data:', error);
        });
    }, [id]);

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Configuración</li>
                        <li className="breadcrumb-item"><Link to="/catalogs/type-services">Tipos de servicio</Link></li>
                        <li className="breadcrumb-item active">Edición de Tipo de servicio</li>
                    </ol>
                    <h1 className="page-header mb-0">Edición de Tipo de servicio</h1>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Edición de Tipo de servicio</PanelHeader>
                        <PanelBody>
                            <Formik
                                enableReinitialize
                                validationSchema={yup.object().shape({
                                    type_service_name: yup.string().required("Ingrese el nombre del Tipo de servicio"),
                                })}
                                onSubmit={(values, { setSubmitting }) => {
                                    setSubmitting(false);
                                    axiosClient.put(`/typeServices/${id}`, values).then(response => {
                                        Swal.fire({
                                            title: 'Cambios guardados',
                                            text: 'El Tipo de servicio se ha actualizado exitosamente',
                                            icon: 'success',
                                            confirmButtonText: 'Cerrar'
                                        });
                                        navigate('/catalogs/type-services');
                                    }).catch(err => {
                                        let message = '';
                                        if (err.response?.data?.original?.code === '23505') {
                                            message = 'El nombre del Tipo de servicio ya existe. Ingresa uno diferente.';
                                        } else {
                                            message = err.response?.data?.message || 'Error al actualizar.';
                                        }
                                        Swal.fire({
                                            title: 'Ups!',
                                            text: message,
                                            icon: 'error',
                                            confirmButtonText: 'Cerrar'
                                        });
                                    });
                                }}
                                initialValues={initialValues}
                            >
                                {({ handleSubmit, handleChange, values, errors }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12">
                                                <Form.Label>Nombre del Tipo de servicio</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="type_service_name"
                                                    placeholder="Nombre del Tipo de servicio"
                                                    value={values.type_service_name}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.type_service_name}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.type_service_name}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Button type="submit">Guardar cambios</Button>{' '}
                                                <Link to="/catalogs/type-services" className="btn btn-info">Cancelar</Link>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>
                        </PanelBody>
                    </Panel>
                </div>
            </div>
        </div>
    );
}

export default EditTypeService;
